/**
 * @file contains formatter function for plural elements in different languages
 */
import { Locale } from '../generated/graphql';

const pr = new Intl.PluralRules('en-US', { type: 'ordinal' });

/**
 * Translations for ordinal number suffixes
 */
const suffixes: Record<string, Map<string, string>> = {
  de: new Map([
    ['one', '.'],
    ['two', '.'],
    ['few', '.'],
    ['other', '.'],
  ]),
  en: new Map([
    ['one', 'st'],
    ['two', 'nd'],
    ['few', 'rd'],
    ['other', 'th'],
  ]),
  fr: new Map([
    ['one', 'er'],
    ['two', 'ème'],
    ['few', 'ème'],
    ['other', 'ème'],
  ]),
  it: new Map([
    ['one', '°'],
    ['two', '°'],
    ['few', '°'],
    ['other', '°'],
  ]),
  nl: new Map([
    ['one', 'e'],
    ['two', 'e'],
    ['few', 'e'],
    ['other', 'e'],
  ]),
};

/**
 * Format ordinal number for current languange
 *
 * @param num    Number to format
 * @param locale Current locale
 * @returns      Formatted number
 */
const formatOrdinalNumber = (num: string, locale: Locale) => {
  const rule = pr.select(parseInt(num, 10));
  const suffix = suffixes[locale].get(rule);
  return `${num}${suffix}`;
};

export default formatOrdinalNumber;
